import { PaginationFilters } from '@reliance/types/filters/PaginationFilters';
import { FacilityNote } from '@reliance/types/models/FacilityNote';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { IPaginatedResponse } from '../common/reliance-api-service';

type FacilityNoteFilters = PaginationFilters & {
  facilityId?: number;
  note?: string;
  userName?: string;
  userId?: number;
};

export const useFacilityNotes = (filters: FacilityNoteFilters) => {
  return useAsync<IPaginatedResponse<FacilityNote>>(
    () => api.get('/facility-note', { params: filters })
      .then((res) => res.data),
    [filters]
  );
};
